import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../utils/api';


// Thunk to fetch top categories
export const getCategoryHeirarchy = createAsyncThunk(
  'categoryHeirarchy/getCategoryHeirarchy',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.getCategoryHeirarchy(); 
 
      
      return response.data?.data;
    } catch (error) {
        console.log(error);
    }
  }
);

// Slice for categories
const categoryHeirarchy = createSlice({
  name: 'category',
  initialState: {
    categoryHeirarchy: [],
    loading: false,
    error: null,
  },
  reducers: {
  
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCategoryHeirarchy.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCategoryHeirarchy.fulfilled, (state, action) => {
        state.loading = false;
        state.categoryHeirarchy = action.payload;
      })
      .addCase(getCategoryHeirarchy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default categoryHeirarchy.reducer;

